<template>
  <v-container>
    <v-row justify="center">
      <v-btn class="my-10" outlined to="/elements/create" v-if="admin">Nouvel élément d'inventaire</v-btn>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-alert border="top" colored-border type="info" elevation="2" dismissible v-if="latest" color="grey lighten-1"> 
          Dernier élément d'inventaire ajouté :
          <a :href="`/elements/${latest._id}`">{{latest.inventoryNumber}} - {{latest.name}}</a>
        </v-alert>
      </v-col>
    </v-row>
    <reactive-base
      app="elements"
      :url="apiUri"
      :headers="{authorization: `Bearer ${this.$keycloak.token}`}"
    >
      <v-row justify="center">
        <v-col cols="12" sm="8">
          <data-search
            componentId="search"
            placeholder="Rechercher un élément..."
            data-field="data"
            :field-weight="[3,1,2]"
            :fuzziness="0"
            :size="10"
            :debounce="100"
            :URLParams="true"
            :autosuggest="false"
            :innerClass="innerClass"
            :customQuery="(value) => ({
              query: {
                query_string: {
                  query: `*${value}*`,
                  fields: ['name', 'brand', 'type', 'inventoryNumber'],
                  default_operator: 'AND'
                }
              }
            })"
          />
          <reactive-component componentId="inOut">
            <div slot-scope="{ aggregations, hits, setQuery }">
              <check-box-wrapper :aggregations="aggregations" :hits="hits" :setQuery="setQuery" />
            </div>
          </reactive-component>
        </v-col>
        <v-col cols="12" sm="8" xl="10">
          <reactive-list
            componentId="ReactiveList"
            :react="{ and: ['search', 'inOut']}"
            data-field="name"
            sortBy="asc"
            :steam="true"
            :sortOptions="sortOptions"
            :URLParams="true"
          >
            <div slot="renderItem" slot-scope="{ item }">
              <v-card
                :color="item.deletedDate ? 'grey lighten-3' : ''"
                class="my-5"
                @click="$router.push(`/elements/${item._id}`)"
                :ripple="false"
              >
                <v-card-title>
                  {{item.name}}
                  <v-spacer />
                  <v-tooltip left v-if="item.group">
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span>{{item.group.name}}</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-subtitle>{{item.inventoryNumber}}</v-card-subtitle>
              </v-card>
            </div>
          </reactive-list>
        </v-col>
      </v-row>
    </reactive-base>
    <v-snackbar v-model="snackbar.visible" :bottom="true" :left="true" :color="snackbar.color">
      {{snackbar.text}}
      <v-btn dark text @click="snackbar.visible = false">Fermer</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import CheckBoxWrapper from "@/components/CheckBoxWrapper";
export default {
  props: ["prevRoute", "latest", "admin"],
  components: {
    CheckBoxWrapper
  },
  mounted() {
    this.timeout = setTimeout(() => {
      if (this.prevRoute === "#delete") {
        this.snackbar.visible = true;
        this.snackbar.text = "Élement supprimé avec succès";
        this.snackbar.color = "success";
      }
    }, 200);
  },
  beforeDestroy: function() {
    clearTimeout(this.timeout);
  },
  data: () => ({
    apiUri: process.env.VUE_APP_API_URI,
    timeout: undefined,
    snackbar: {
      visible: false,
      text: "",
      color: ""
    },
    sortOptions: [
      {
        label: "Numero d'inventaire (asc)",
        dataField: "inventoryNumber",
        sortBy: "asc"
      },
      {
        label: "Numéro d'inventaire (desc)",
        dataField: "inventoryNumber",
        sortBy: "desc"
      },
      { label: "Nom (asc)", dataField: "name.raw", sortBy: "asc" },
      { label: "Nom (desc)", dataField: "name.raw", sortBy: "desc" },
      { label: "Date d'entrée (asc)", dataField: "addedDate", sortBy: "asc" },
      { label: "Date d'entrée (desc)", dataField: "addedDate", sortBy: "desc" }
    ],
    innerClass: {
      title: "text-title",
      input: "text-input"
    }
  })
};
</script>

<style>
.text-input {
  border-radius: 4px;
}
</style>